module.exports = __webpack_public_path__ + "static/img/map__currentlocation__mylocation__icon.4404b556.svg";